import { queryOptions } from '@tanstack/react-query'
import { api, unwrap } from '~/lib/api'

// The own account is personal (not team- or season-bound): keys start with 'account'.
export const accountKeys = {
  all: ['account'] as const,
  profile: ['account', 'profile'] as const,
  sessions: ['account', 'sessions'] as const,
  pushKey: ['account', 'push-key'] as const,
}

export const accountQuery = queryOptions({
  queryKey: accountKeys.profile,
  queryFn: () => unwrap(api.account.$get()),
})

export const sessionsListQuery = queryOptions({
  queryKey: accountKeys.sessions,
  queryFn: () => unwrap(api.account.sessions.$get()),
})

export const pushKeyQuery = queryOptions({
  queryKey: accountKeys.pushKey,
  queryFn: () => unwrap(api.account.push.key.$get()),
  staleTime: Infinity,
})

export type Device = Awaited<ReturnType<NonNullable<typeof sessionsListQuery.queryFn>>>[number]
